document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.getElementById("product-search");
  const grid = document.getElementById("ShopProductsGrid");

  if (!searchInput || !grid) return;

  // Detect collection handle from URL (/collections/{handle})
  const match = window.location.pathname.match(/\/collections\/([^/]+)/);
  const collectionHandle = match ? match[1] : null;
  if (!collectionHandle) return;

  // Decide which card template to use
  const snippetView = (collectionHandle === "resources")
    ? "ss-resource-card"
    : "product-card";

  let allProducts = [];
  let originalGridHTML = grid.innerHTML; // save Aurora’s markup for reset
  let debounceTimer = null;

  // Aurora pagination element
  const paginationEl = document.querySelector("pagination-component.load-button-pagination");

  // -------------------------------
  // Helpers
  // -------------------------------
  async function fetchProducts(handle) {
    let page = 1;
    let products = [];
    let hasMore = true;

    while (hasMore) {
      const res = await fetch(`/collections/${handle}/products.json?page=${page}&limit=250`);
      const data = await res.json();

      if (data.products && data.products.length > 0) {
        products = products.concat(data.products);
        page++;
      } else {
        hasMore = false;
      }
    }
    return products;
  }

  function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  function normalizeText(str) {
    return (str || "")
      .toLowerCase()
      .normalize("NFD")                  // split accents from letters
      .replace(/\p{Diacritic}/gu, "")    // remove diacritics
      .replace(/['"`´’\-.,!?]/g, "")     // remove punctuation
      .replace(/\s+/g, " ")              // collapse whitespace
      .trim();
  }

  async function fetchCard(handle) {
    const url = `/products/${handle}?view=${snippetView}`;
    const res = await fetch(url);
    return res.text();
  }

  function showLoading() {
    grid.innerHTML = `
      <div class="loading-spinner-wrap">
        <p>Loading results...</p>
      </div>
    `;
  }

  async function renderProducts(products) {
    if (products.length === 0) {
      grid.innerHTML = `
        <div class="no-results">
          <p>No results found. Please try a different search.</p>
        </div>
      `;
      return;
    }

    // Fetch all cards in parallel
    const cardPromises = products.map(prod =>
      fetchCard(prod.handle).catch(err => {
        console.error("❌ Error fetching card for", prod.handle, err);
        return "";
      })
    );

    const cardHtmlArray = await Promise.all(cardPromises);
    grid.innerHTML = cardHtmlArray.join("");
  }

  function applyFilter(query) {
    query = normalizeText(query);

    if (!query) {
      console.log("Empty query → restoring Aurora’s original grid");
      grid.innerHTML = originalGridHTML;
      if (paginationEl) paginationEl.style.display = ""; // restore pagination
      return;
    }

    console.log("🔎 Normalized search query:", query);

    showLoading();
    if (paginationEl) paginationEl.style.display = "none"; // hide pagination during search

    const terms = query.split(" ");
    const filtered = allProducts.filter(prod => {
      const haystack = normalizeText(
        prod.title + " " + prod.vendor + " " + stripHtml(prod.body_html)
      );
      return terms.every(term => haystack.includes(term));
    });

    console.log("✅ Filtered products count:", filtered.length);
    renderProducts(filtered);
  }

  // -------------------------------
  // Init
  // -------------------------------
  fetchProducts(collectionHandle).then(products => {
    allProducts = products;
    console.log("Cached all products:", allProducts.length);
    // Don’t render → let Aurora’s pagination show initially
  });

  // Debounced search on input
  searchInput.addEventListener("input", () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      applyFilter(searchInput.value);
    }, 300);
  });

  // Instant search on Enter
  searchInput.addEventListener("keydown", e => {
    if (e.key === "Enter") {
      clearTimeout(debounceTimer);
      applyFilter(searchInput.value);
    }
  });
});
